import { Meeting, MeetingSummary } from '@/types/Meeting';

export function convertMeetingToMeetingSummary(meeting: Meeting): MeetingSummary {
  return {
    meeting_id: meeting.meeting_id,
    title: meeting.title,
    meeting_url: meeting.meeting_url,
    meeting_start_time: meeting.meeting_start_time,
    meeting_end_time: meeting.meeting_end_time,
    timestamp: meeting.timestamp,
    status: meeting.status
  };
}

export function convertMeetingSummaryToMeeting(meetingSummary: MeetingSummary): Meeting {
  return {
    meeting_id: meetingSummary.meeting_id,
    title: meetingSummary.title,
    meeting_url: meetingSummary.meeting_url,
    meeting_start_time: meetingSummary.meeting_start_time,
    meeting_end_time: meetingSummary.meeting_end_time,
    timestamp: meetingSummary.timestamp,
    status: meetingSummary.status,
    bot_id: '',
    bot_name: '',
    meeting_url_info: {
      meeting_id: meetingSummary.meeting_id,
      meeting_password: '',
      tk: null,
      platform: ''
    },
    video_url: '',
    transcripts: []
  };
}
